import type {SxProps} from '@mui/material';
import type {ManifestationStatus as ManifestationStatusType} from 'services/metadata/types';
import {px2rem} from 'theme';
import {
  useManifestationStatusColor,
  useManifestationStatusLabel,
} from 'services/utils';
import {Layout, Text} from 'components';

type Props = {
  status: ManifestationStatusType;
  mode?: 'default' | 'mini';
};

const sx: SxProps = {
  height: px2rem(29),
  px: px2rem(14),
  borderRadius: 1,
};

export const ManifestationStatus: React.FC<Props> = ({status, mode}) => {
  const label = useManifestationStatusLabel(status, mode);
  const color = useManifestationStatusColor(status);

  return (
    <Layout bgcolor={color} adjustCenter sx={sx}>
      <Text kind="primary" variant="body2">
        {label}
      </Text>
    </Layout>
  );
};
